module.exports = __webpack_public_path__ + "static/media/line-half.c80ac400.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/line-half.svg
// module id = 745
// module chunks = 0